export default "__VITE_ASSET__Be6MPD1e__"